import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db, waitForAuthReady } from './firebase';

export interface AnnouncementItem {
  id: string;
  title: string;
  content: string;
  priority: 'low' | 'medium' | 'high' | 'urgent';
  targetAudience: 'all' | 'teachers' | 'students';
  displayLocation?: 'all' | 'home' | 'class-student' | 'class-teacher';
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  expiresAt?: Date;
}

export const getActiveAnnouncements = async (): Promise<AnnouncementItem[]> => {
  try {
    await waitForAuthReady();
    const announcementsRef = collection(db, 'announcements');
    const q = query(announcementsRef, orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    const now = new Date();

    const list = snapshot.docs.map((item) => ({
      id: item.id,
      ...item.data(),
      createdAt: item.data().createdAt?.toDate() || new Date(),
      updatedAt: item.data().updatedAt?.toDate() || new Date(),
      expiresAt: item.data().expiresAt?.toDate()
    })) as AnnouncementItem[];

    return list.filter((announcement) => {
      if (!announcement.isActive) {
        return false;
      }
      if (announcement.expiresAt && announcement.expiresAt < now) {
        return false;
      }
      return true;
    });
  } catch (error) {
    console.error('활성 공지 조회 중 오류:', error);
    return [];
  }
};
